"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { getLocalizedHref } from "@/lib/config/lib/helper"
import { PromotionListRenderProps } from "@/types/types"
import { useParams } from "next/navigation"
import { useMemo } from "react"
import { twMerge } from "tailwind-merge"

import { generateResponsiveCSS } from "../../../lib/helper"
import { PromotionListContent } from "./components/PromotionListContent"
import { usePromotionListByCategory } from "./hooks/usePromotionListByCategory"

export const RenderConfig = {
  render: ({
    title,
    viewAllLink,
    category,
    pageSize = 20,
    slidesPerView = 3,
    spaceBetween = 16,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: PromotionListRenderProps) => {
    const params = useParams()
    const storeLocale = useUIBuilderLocaleStore(state => state.locale)
    const locale = (params?.locale as string) || storeLocale || "vi"
    const id = useMemo(() => componentId || `promotion-list-${Math.random().toString(36).substr(2, 9)}`, [componentId])
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    const { posts, loading } = usePromotionListByCategory(category?.categoryId, pageSize, locale)

    const finalViewAllLink = useMemo(() => {
      const rawLink = viewAllLink || (category?.slug ? `/category/${category.slug}` : undefined);
      if (!rawLink) return undefined;

      return getLocalizedHref(rawLink, locale);
    }, [viewAllLink, category?.slug, locale]);

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <PromotionListContent
            id={id}
            title={title}
            viewAllLink={finalViewAllLink}
            locale={locale}
            posts={posts}
            loading={loading}
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            className={className}
          />
        </div>
      </>
    )
  },
}
